import * as React from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';

import Select, { Option } from '@/components/elements/Form/Select';
import NewsIndexList from '@/components/layouts/News/IndexList';
import NewsIndexListSkeleton from '@/components/layouts/News/IndexList/Skeleton';
import NewsTypeSelector from '@/components/layouts/News/NewsTypeSelector';
import { Author } from '@/lib/microcms/client/types/model';
import { getNewsTypeName } from '@/lib/news';
import { Content, NewsType } from '@/pages/News/types';

import {
  AuthorSelector,
  Container,
  ContentEmptyMessage,
  Contents,
} from './style';

interface NewsTemplateProps {
  contents: Content[];
  authors: Author[];
  selectedAuthorId: string;
  newsType: NewsType;
  loading: boolean;
  hasNextPage: boolean;
  fetchContents: (initialize?: boolean, filters?: string) => void;
  setSelectedAuthorId: React.Dispatch<React.SetStateAction<string>>;
}

const NewsTemplate: React.FC<NewsTemplateProps> = ({
  contents,
  authors,
  selectedAuthorId,
  newsType,
  loading,
  hasNextPage,
  fetchContents,
  setSelectedAuthorId,
}) => {
  const [infiniteRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore: fetchContents,
    rootMargin: '0px 0px 400px 0px',
  });

  const options: Option[] = [
    {
      value: '',
      displayName: '全て',
    },
    ...authors.map(author => ({
      value: author.id,
      displayName: author.name,
    })),
  ];

  return (
    <Container>
      <NewsTypeSelector newsType={newsType} isIndex />
      <>
        <Contents>
          {newsType === NewsType.Blog && (
            <AuthorSelector>
              <Select
                options={options}
                value={selectedAuthorId}
                placeholder="著者選択"
                width="100%"
                height="46px"
                isCenter
                onChange={e => setSelectedAuthorId(e.target.value)}
              />
            </AuthorSelector>
          )}
          <>
            {contents.length ? (
              <NewsIndexList type={newsType} contentsList={contents} />
            ) : (
              <>
                {!loading && (
                  <ContentEmptyMessage>
                    {getNewsTypeName(newsType)}がありません
                  </ContentEmptyMessage>
                )}
              </>
            )}
          </>
          {loading && (
            <NewsIndexListSkeleton
              type={newsType}
              count={10}
              visiblePublishedAt
            />
          )}
        </Contents>
        {!loading && hasNextPage && <div ref={infiniteRef} />}
      </>
    </Container>
  );
};

export default NewsTemplate;
